import { faShoppingCart } from "@fortawesome/duotone-light-svg-icons"
import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import CoinsReadyToRedeemCard from "./CoinsReadyToRedeemCard"
import ConfirmRedeemChildRewardModal from "./ConfirmRedeemChildRewardModal"
import RedeemChildRewardModal from "./RedeemChildRewardModal"
import { useCoinTransactionsModalStore } from "./useTransactionsModalStore"
import {
  useCoinCulumativeStatsThisWeekQuery,
  useUserQuery,
} from "../../../networking/queries"
import useFamilyUserSelectStore from "../hooks/useFamilyUserSelect"
import useSelectedFamilyMember from "../hooks/useSelectedFamilyMember"
import {
  InventoryGiftShopModalTab,
  useInventoryGiftShopModalStore,
} from "../parentUser/mailbox/hooks/useInventoryGiftShopModalStore"

const CoinStatementSection = () => {
  const { selectedProfile } = useSelectedFamilyMember()
  const { selectedUserId } = useFamilyUserSelectStore()
  const { data: stats } = useCoinCulumativeStatsThisWeekQuery(
    selectedProfile?.user.id!
  )
  const { onOpen: openCoinTransactionsModal } = useCoinTransactionsModalStore()
  const { onOpen: openInventoryGiftShopModal, setSelectedTab } =
    useInventoryGiftShopModalStore()
  const { user } = useUserQuery()
  const { t } = useTranslation()

  const isParentUser = user?.id === selectedProfile?.user.id

  const handleSeeHistory = () => {
    openCoinTransactionsModal(selectedProfile?.user)
  }

  const handleShop = () => {
    openInventoryGiftShopModal()
    setSelectedTab(InventoryGiftShopModalTab.GIFT_SHOP)
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row justify-between">
        <div className="flex flex-row gap-1 items-center">
          <img
            src="images/icons/coin-icon.png"
            alt="coin"
            className="w-3 h-3"
          />
          <Typography variant="bodyBold">{t("CT_COIN_STATEMENT")}</Typography>
        </div>
        <button onClick={handleSeeHistory}>
          <Typography
            variant="bodySmallBold"
            color={JoonUIColor.text.primaryAccent}
          >
            {t("CT_SEE_HISTORY")}
          </Typography>
        </button>
      </div>
      <CoinsReadyToRedeemCard childId={selectedUserId!} allowRedeem />
      <div className="flex justify-between items-center gap-2 p-3 bg-bgLightGray rounded-md">
        <div className="flex flex-col gap-2">
          <Typography variant="h3">{selectedProfile?.user.coins}</Typography>
          <Typography variant="bodySmall">{t("CT_TOTAL_AVAILABLE")}</Typography>
        </div>
        {isParentUser && (
          <Button
            buttonType="secondary"
            size="small"
            text={t("CT_SHOP")}
            icon={faShoppingCart}
            onClick={handleShop}
          />
        )}
      </div>
      <div className="flex flex-row gap-1">
        <div className="flex flex-col gap-2 p-3 bg-viridian-100 rounded-md w-full">
          <Typography variant="h3">{stats?.coins_earned}</Typography>
          <Typography variant="bodySmall">
            {t("CT_EARNED_THIS_WEEK")}
          </Typography>
        </div>
        <div className="flex flex-col gap-2 p-3 bg-red-100 rounded-md w-full">
          <Typography variant="h3">{stats?.coins_spent}</Typography>
          <Typography variant="bodySmall">{t("CT_SPENT_THIS_WEEK")}</Typography>
        </div>
      </div>
      <RedeemChildRewardModal />
      <ConfirmRedeemChildRewardModal />
    </div>
  )
}

export default CoinStatementSection
